<template>
  <div class="account-settings-info-view">
    <a-row :gutter="10">
      <a-col :xs="24" :lg="16">
        <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
          <!-- 手机号码 -->
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="Mobile"
            hasFeedback
          >
            <a-input
              maxlength="11"
              placeholder="Please input your mobile"
              v-decorator="[
                'mobile',
                {rules: [
                  { required: true, message: 'Please input your mobile' }
                  // { pattern: /^1[3|4|5|8][0-9]\d{4,8}$/, message: '不是有效的手机号码' }
                ]}
              ]"
            ></a-input>
          </a-form-item>
          <!-- 邮箱地址 -->
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="EMail"
            hasFeedback
          >
            <a-input
              maxlength="100"
              placeholder="Please input your email address"
              v-decorator="[
                'email',
                {rules: [{ type: 'email', required: true, message: 'Please input your email address' }]}
              ]"
            ></a-input>
          </a-form-item>
          <!-- 隐藏域 -->
          <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
          <a-form-item v-bind="buttonCol">
            <a-row class="btn-box" style="padding-left: 16.5%;">
              <a-button type="primary" html-type="submit" :loading="submitting">Save</a-button>
            </a-row>
          </a-form-item>
        </a-form>

      </a-col>
      <a-col :xs="24" :lg="8" :style="{ minHeight: '180px' }">
        <!-- 隐藏头像上传功能 -->
        <div v-if="false" class="ant-upload-preview" @click="$refs.modal.edit(1)" >
          <a-icon type="cloud-upload-o" class="upload-icon"/>
          <div class="mask">
            <a-icon type="plus" />
          </div>
          <img :src="option.img"/>
        </div>
      </a-col>

    </a-row>
    <avatar-modal ref="modal"></avatar-modal>
  </div>
</template>

<script>
import AvatarModal from './AvatarModal'
import { getMyInfo, putMyProfile } from '@/api/api-adminer'

export default {
  components: {
    AvatarModal
  },
  data () {
    return {
      // cropper
      // preview: {},
      // option: {
      //   img: '/avatar2.jpg',
      //   info: true,
      //   size: 1,
      //   outputType: 'jpeg',
      //   canScale: false,
      //   autoCrop: true,
      //   // 只有自动截图开启 宽度高度才生效
      //   autoCropWidth: 180,
      //   autoCropHeight: 180,
      //   fixedBox: true,
      //   // 开启宽度和高度比例
      //   fixed: true,
      //   fixedNumber: [1, 1]
      // }
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      submitting: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadEditInfo()
    })
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      const that = this
      // eslint-disable-next-line
      that.editForm.validateFields((err, fieldsValue) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = that.editForm.getFieldsValue()
        that.submitting = true
        putMyProfile(formData)
          .then(res => {
            if (res.success) {
              that.mixinProcessSuccessNotification('Save successfully !')
            } else {
              that.mixinProcessHasBizErrorNotification(res)
            }
            that.submitting = false
          })
          .catch(e => {
            that.mixinErrorNotification(`Save fail: ${e.message}`)
            console.log('e', e)
            that.submitting = false
          })
      })
    },
    loadEditInfo () {
      const that = this
      getMyInfo()
        .then(res => {
          if (res.success) {
            const info = res.data
            var formData = { 'id': info.id, 'mobile': info.mobile, 'email': info.email }
            console.debug('formData', formData)
            this.editForm.setFieldsValue(formData)
          } else {
            that.mixinProcessHasBizErrorNotification(res)
          }
        })
        .catch(e => {
          that.mixinErrorNotification(`Save fail: ${e.message}`)
          console.log('e', e)
        })
    }
  }
}
</script>

<style lang="less" scoped>

  .avatar-upload-wrapper {
    height: 200px;
    width: 100%;
  }

  .ant-upload-preview {
    position: relative;
    margin: 0 auto;
    width: 100%;
    max-width: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;

    .upload-icon {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 1.4rem;
      padding: 0.5rem;
      background: rgba(222, 221, 221, 0.7);
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .mask {
      opacity: 0;
      position: absolute;
      background: rgba(0,0,0,0.4);
      cursor: pointer;
      transition: opacity 0.4s;

      &:hover {
        opacity: 1;
      }

      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }

    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      border-radius: 50%;
      overflow: hidden;
    }
  }
</style>
